import { useState } from 'react';
import api from '../../api/api';
import validation from '../../helpers/validation';
import Button from '../shared/button';
import TextInput from '../shared/textInput';
import TextInputArea from '../shared/textInputArea';
import './contact.css';

const Contact = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [notice, setNotice] = useState({ type: '', text: '' });

    const handleSubmit = async () => {
        const normalizedEmail = email.trim().toLowerCase();
        const trimmedMessage = message.trim();

        if (!validation.validateEmail(normalizedEmail)) {
            setNotice({ type: 'error', text: 'Please enter a valid email address.' });
            return;
        }

        if (!trimmedMessage) {
            setNotice({ type: 'error', text: 'Please enter a message before sending.' });
            return;
        }

        setSubmitting(true);
        setNotice({ type: '', text: '' });

        try {
            const payload = {
                to: 'davebradham@gmail.com',
                replyTo: normalizedEmail,
                message: `From: ${normalizedEmail}\n\n${trimmedMessage}`,
                subject: 'Contact Request - Roots & Robust Property Management'
            };

            await api.post('/email', payload);
            setSubmitted(true);
            setEmail('');
            setMessage('');
        } catch (e) {
            const backendError = e?.response?.data?.error;
            setNotice({ type: 'error', text: backendError || 'Unable to send your message right now. Please try again.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="contact-container">
            <div className="contact-header">
                <h2>Get In Touch</h2>
                <p>Have questions about our property management platform or need consulting advice as you get started? We'd love to hear from you.</p>
            </div>

            <div className="contact-content">
                <div className="contact-info">
                    <div className="info-card">
                        <h3>📧 Email Us</h3>
                        <p>Send us a message and we'll get back to you within 24 hours with guidance on software, operations, or getting your first systems in place.</p>
                        <div className="contact-details">
                            <strong>Email:</strong> davebradham@gmail.com<br/>
                            <strong>Response Time:</strong> Within 24 hours
                        </div>
                    </div>

                    <div className="info-card info-card-consulting">
                        <h3>🧭 Consulting & Advice</h3>
                        <p>We can help new owners think through launch planning, reporting habits, vendor coordination, and early operating decisions.</p>
                        <div className="contact-details">
                            <strong>Best For:</strong> New operators and growing teams<br/>
                            <strong>Topics:</strong> Setup, process, compliance, and performance reviews
                        </div>
                    </div>

                    <div className="info-card">
                        <h3>🏢 Our Location</h3>
                        <p>Based in Austin, Texas, serving property owners nationwide.</p>
                        <div className="contact-details">
                            <strong>Location:</strong> Austin, TX<br/>
                            <strong>Service Area:</strong> Nationwide
                        </div>
                    </div>
                </div>

                <div className="contact-form">
                    {!submitted ? (
                        <>
                            <h3>Send us a Message</h3>
                            {notice.text && <div className={`app-notice ${notice.type === 'error' ? 'app-notice-error' : 'app-notice-success'}`}>{notice.text}</div>}
                            <div className="form-group">
                                <label htmlFor="email">Your Email Address *</label>
                                <TextInput
                                    id="email"
                                    value={email}
                                    onChange={setEmail}
                                    className="contact-input"
                                    placeholder="your.email@example.com"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Your Message *</label>
                                <TextInputArea
                                    id="message"
                                    value={message}
                                    onChange={setMessage}
                                    className="contact-textarea"
                                    placeholder="Tell us about your property management or consulting needs..."
                                    rows={6}
                                />
                            </div>

                            <Button onClick={handleSubmit} text={submitting ? "Sending..." : "Send Message"} className="contact-submit-btn" disabled={submitting} />
                        </>
                    ) : (
                        <div className="success-message">
                            <h3>✅ Message Sent!</h3>
                            <p>Thank you for contacting us. We'll get back to you within 24 hours with next steps and any guidance that may help you get started.</p>
                            <Button onClick={() => setSubmitted(false)} text="Send Another Message" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Contact;